import {
  FormGroup,
  FormControlLabel,
  Checkbox,
  Typography,
} from '@mui/material'
import theme from 'lib/theme'
import React from 'react'

type CheckboxLabelProps = {
  value: boolean
  handleChange: () => void
  label: string
}

export const CheckboxLabel = ({
  value,
  handleChange,
  label,
}: CheckboxLabelProps) => {
  return (
    <FormGroup>
      <FormControlLabel
        control={
          <Checkbox
            checked={value}
            onChange={handleChange}
            sx={{
              '&.Mui-checked .MuiSvgIcon-root': {
                fill: theme.palette.primary.main,
              },
            }}
          />
        }
        label={
          <Typography variant='body2' sx={{ fontSize: '12px' }}>
            {label}
          </Typography>
        }
      />
    </FormGroup>
  )
}
